import React from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';

import About from './components/about';
import Articles from './components/articles';
import Contacts from './components/contacts';
import Footer from './components/footer';
import Home from './components/home';
import NavigationBar from './components/navigation';
import Services from './components/services';
import ScrollToTop from "./components/scrolltotop";


function App() {
    return (
        <BrowserRouter>
            <NavigationBar />
            <ScrollToTop>
                <AnimatedSwitch atEnter={{ opacity: 0 }} atLeave={{ opacity: 1 }} atActive={{ opacity: 1 }}>
                    <Route exact path='/' component={Home} />
                    <Route path="/about" component={About} />
                    <Route path='/specialization' component={Services} />
                    <Route path='/contacts' component={Contacts} />
                    <Route path='/articles' component={Articles} />
                    <Redirect from='/*' to='/' />
                </AnimatedSwitch>
            </ScrollToTop>
            <Footer />
        </BrowserRouter>
    );
}

export default App;
